import React from 'react'
import PropTypes from 'prop-types'

import S from '../Loading.styled'

const Subtitle = ({ className }) => {
  return <S.Subtitle className={className}></S.Subtitle>
}

Subtitle.propTypes = {
  className: PropTypes.string,
}

export default Subtitle
